import { createGlobalStyle } from 'styled-components';
import reset from 'styled-reset';

const GlobalStyles = createGlobalStyle`
  ${reset};
  * {
    box-sizing: border-box;
    outline: 0;
  }
  html,body {
    font-family: 'Noto Sans KR', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    font-size: 14px;
    font-weight: 400;
    background: #f9fcff;
    color: #313131;
  }
  body {
    overflow-y: scroll;
  }
  a {
    text-decoration: none;
    color: inherit;
  }
  img {
    vertical-align: top;
  }
  button {
    cursor: pointer;
    border: 0;
    background: transparent;
    padding: 0;
  }
  input,
  button {
    font: inherit;
  }
  select {
    appearance: none;
  }

  /* 티어 컬러 */
  .tier_color {
    &.challenger {
      color: #EE7A00;
    }
    &.grandmaster {
      color: #C23449;
    }
    &.master {
      color: #863DA1;
    }
    &.diamond {
      color: #2898C9;
    }
    &.platinum {
      color: #1DA794;
    }
    &.gold {
      color: #BA8D26;
    }
    &.silver {
      color: #6A79AB;
    }
    &.bronze {
      color: #876B26;
    }
    &.iron {
      color: #5A5959;
    }
    &.unrank {
      color: #313131;
    }
  }

  /* 티어 뱃지 */
  .tier_badge {
    display: inline-block;
    width: 23px;
    height: 19px;
    line-height: 19px;
    font-size: 12px;
    font-weight: 400;
    color: #fff;
    text-align: center;
    border-radius: 7px;

    &.challenger {
      font-size: 14px;
      background: transparent linear-gradient(180deg, #FEE54C 0%, #FC9F3F 100%);
    }
    &.grandmaster {
      width: 28px;
      font-size: 14px;
      background: transparent linear-gradient(180deg, #DE435B 0%, #9A2A3B 100%);
    }
    &.master {
      font-size: 14px;
      background: transparent linear-gradient(180deg, #A54CC5 0%, #793791 100%);
    }
    &.diamond {
      background: transparent linear-gradient(180deg, #429EC8 0%, #2E708E 100%);
    }
    &.platinum {
      background: transparent linear-gradient(180deg, #38B8A7 0%, #298074 100%);
    }
    &.gold {
      background: transparent linear-gradient(180deg, #DEAD3B 0%, #98782C 100%);
    }
    &.silver {
      background: transparent linear-gradient(180deg, #8691B5 0%, #5E657D 100%);
    }
    &.bronze {
      background: transparent linear-gradient(180deg, #A2843C 0%, #715C27 100%);
    }
    &.iron {
      background: transparent linear-gradient(180deg, #818181 0%, #636363 100%);
    }
  }

  /* 점수 컬러 */
  .score_color {
    &.verygood {
      color: #F19000;
    }
    &.good {
      color: #259A7E;
    }
    &.bad {
      color: #DE5353;
    }
    &.verybad {
      color: #69788D;
    }
  }

  /* KDA 컬러 */
  .kda_color {
    &.perfect {
      color: #F19000;
    }
    &.high {
      color: #F19000;
    }
    &.middle {
      color: #259A7E;
    }
    &.low {
      color: #69788D;
    }
  }

  /* mvp, ace 뱃지 */
  .crown {
    display: inline-block;
    width: 22px;
    height: 16px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;

    &.mvp {
      background-image: url('/images/ico_crown_gold_w.svg');
    }
    &.ace {
      background-image: url('/images/ico_crown_silver_w.svg');
    }
  }

  /* 승급전 */
  
  .promos {
    position: relative;
    margin-top: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 0;
      display: block;
      width: 100%;
      height: 1px;
      background: #707070;
      z-index: 1;
    }

    span {
      position: relative;
      z-index: 2;
      display: flex !important;
      align-items: center;
      justify-content: center;
      width: 18px;
      height: 18px;
      background-color: #c0c9d1;
      border: 2px solid #fff;
      border-radius: 50%;
      box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2);
      font-size: 11px;
      font-weight: 400;
      color: #fff;

      &.W {
        background-color: #5092cc;
      }
      &.L {
        background-color: #c24a4a;
      }
      &.N {
        font-size: 0;
        text-indent: -9999px;
      }
    }
  }
`;

export default GlobalStyles;
